import VideoCardLandscape from './components/VideoCardLandscape';
import VideoCardPortrait from './components/VideoCardPortrait';
import VideoCardBanner from './components/VideoCardBanner';
import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import { toggleDialog } from '../../store/control/duck';
import { connect } from 'react-redux';
import { useWidth } from '../../utils/hooks';
export { VideoCardLandscape, VideoCardPortrait, VideoCardBanner };

const VideoCard = forwardRef(
  (
    {
      intl,
      type,
      itemData,
      DialogProps,
      onToggleItem,
      onClick,
      shouldShowStatistic,
      statistic,
      enableLanguages,
      toggleDialog,
      toggleDialogShowTags = true,
      maxTagLength = 2,
      ContainerProps,
      ...props
    },
    ref
  ) => {
    const buttonRef = useRef(null);
    const playerRef = useRef(null);

    const handleClick = () => {
      toggleDialog('hotTopicItem', {
        item: itemData,
        onToggleItem,
        shouldShowStatistic,
        statistic,
        enableLanguages,
        toggleDialogShowTags,
        DialogProps: {
          ...DialogProps,
          maxWidth: 'md',
          TransitionProps: {
            triggerTarget: buttonRef.current
          }
        }
      });

      if (onToggleItem) {
        onToggleItem(itemData, true);
      }
    };

    const w = useWidth();
    const isMobile = w === 'xs' || w === 'sm';

    useImperativeHandle(ref, () => ({
      onClick: onClick || handleClick,
      getVideoCard: () => playerRef.current,
      getButton: () => buttonRef.current
    }));

    if (type === 'banner') {
      return (
        <VideoCardBanner
          ref={playerRef}
          autoPlay={true}
          showTags={false}
          showTitle={true}
          isMobile={isMobile}
          locale={intl.locale}
          itemData={itemData}
          intl={intl}
          onClick={onClick || handleClick}
          maxTagLength={maxTagLength}
        />
      );
    } else if (type === 'landscape') {
      return (
        <VideoCardLandscape
          itemData={itemData}
          locale={intl.locale}
          intl={intl}
          onClick={onClick || handleClick}
          maxTagLength={maxTagLength}
        />
      );
    } else {
      return (
        <VideoCardPortrait
          ContainerProps={ContainerProps}
          itemData={itemData}
          locale={intl.locale}
          intl={intl}
          onClick={onClick || handleClick}
          maxTagLength={maxTagLength}
        />
      );
    }
  }
);

const VideoCardContainer = connect(
  state => ({
    hotTopicItemDialog: state.control.hotTopicItemDialog
  }),
  {
    toggleDialog
  },
  null,
  {
    forwardRef: true
  }
)(VideoCard);

export default VideoCardContainer;
